module.exports = __webpack_public_path__ + "img/service2.8ea85f5.svg";